import base from "@/locales/languages/es_MX/view/bases/base";

export default { base };



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/bases/index.js